import { useEffect, useState } from "react";
import { useLocation, Navigate } from "react-router-dom";
import { supabase } from "./supabaseclient";

const PUBLIC = new Set(["/login","/reset-password","/accept-invite","/start-reset"]);

export default function RequireAuth({ children }) {
  const [session, setSession] = useState(undefined);
  const location = useLocation();

  useEffect(() => {
    let mounted = true;
    supabase.auth.getSession().then(({ data: { session } }) => mounted && setSession(session || null));
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_e, s) => {
      mounted && setSession((s?.session ?? s) || null);
    });
    return () => { mounted = false; subscription.unsubscribe(); };
  }, []);

  if (PUBLIC.has(location.pathname)) return children;
  if (session === undefined) return <div style={{textAlign:'center',marginTop:80}}>Loading…</div>;
  if (!session) return <Navigate to="/login" replace />;
  return children;
}
